<template>
  <div>
    <el-row class="cs-filter-row">
      <el-col>
        <el-row class="cs-filter-rowItem">
          <el-col :span="24" class="cs-search-button">
              <el-button
                class="margin-left-20px"
                size="medium"
                type="primary"
                @click="onSearchConditionChanged('', true)">搜索</el-button>
          </el-col>
        </el-row>
        <el-row class="cs-filter-rowItem">
          <el-col :span="4">
            <el-select
              placeholder="类型"
              v-model="selectedSearchType"
              @change="onSearchConditionChanged('searchType')"
              size="medium"
              class="margin-left-20px"
            >
              <el-option
                v-for="item in searchTypes"
                :key="item.Key"
                :label="item.Value"
                :value="item.Key"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4" v-if="selectedSearchType == 2 || selectedSearchType == 3">
            <el-select
              placeholder="业务"
              v-model="courseType"
              @change="onSearchConditionChanged('courseType')"
              size="medium"
              class="margin-left-20px"
            >
              <el-option
                v-for="item in courseTypeList"
                :key="item.Key"
                :label="item.Value"
                :value="item.Key"
              ></el-option>
            </el-select>
          </el-col>
           <el-col :span="4"  v-if="courseType == 3">
            <el-select
              placeholder="业务"
              v-model="selectedTrainingCategory"
              @change="onSearchConditionChanged('trainingCategory')"
              size="medium"
              class="margin-left-20px"
            >
              <el-option
                v-for="item in trainingCategoryList.filter(i => i.Id != 0)"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col
            :span="4"
            v-if="selectedSearchType == 2 || selectedSearchType == 3"
          >
            <el-select
              placeholder="学期"
              v-model="selectedTermId"
              @change="onSearchConditionChanged('term')"
              size="medium"
              class="margin-left-20px"
            >
              <el-option
                v-for="item in termList"
                :key="item.Id"
                :label="item.DisplayLable"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col
            :span="5"
            class="cs-datepick-col"
            v-if="selectedSearchType == 1 || selectedSearchType == 3"
          >
            <el-date-picker
              class="cs-accountList-searchDate margin-left-20px"
              v-model="searchDate"
              type="daterange"
              align="center"
              unlink-panels
              range-separator="-"
              start-placeholder="开始"
              end-placeholder="结束"
              :picker-options="pickerOptions"
              size="medium"
              @change="onSearchConditionChanged"
            ></el-date-picker>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="4" v-if="!USERMANAGER.isFrontDesk && !USERMANAGER.isInternationalSales">
            <el-select
              placeholder="请选择角色"
              filterable
              v-model="selectedRoleType"
              @change="onSearchConditionChanged('role')"
              size="medium"
              class="margin-left-20px"
            >
              <el-option
                v-for="item in roleList"
                :key="item.Key"
                :label="item.Value"
                :value="item.Key"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4" v-if="!USERMANAGER.isFrontDesk && !USERMANAGER.isInternationalSales">
            <el-select
              placeholder="请选择"
              filterable
              v-model="selectedEmployeeId"
              @change="onSearchConditionChanged"
              size="medium"
              class="margin-left-20px"
            >
              <el-option
                v-for="item in employeeListData"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select
              placeholder="大学"
              v-model="selectedGroupNumber"
              @change="onSearchConditionChanged"
              size="medium"
              class="margin-left-20px"
            >
              <el-option
                v-for="item in universityGroups"
                :key="item.GroupNumber"
                :label="item.NameValue"
                :value="item.GroupNumber"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select
              placeholder="请选择"
              v-model="selectedAccountType"
              @change="onSearchConditionChanged"
              size="medium"
              class="margin-left-20px"
            >
              <el-option
                v-for="item in accountTypeList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select
              v-if="selectedAccountType == 9 && selectedSearchType == 1 && courseType != 3"
              placeholder="业务"
              v-model="selectedTrainingCategory"
              @change="onSearchConditionChanged"
              size="medium"
              class="margin-left-20px"
            >
              <el-option
                v-for="item in trainingCategoryList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
            <el-select
              v-if="selectedAccountType == 10"
              placeholder="业务"
              v-model="selectedEnglishCategory"
              @change="onSearchConditionChanged"
              size="medium"
              class="margin-left-20px"
            >
              <el-option
                v-for="item in englishCategoryList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4" v-if="USERMANAGER.isAdmin">
            <el-input
                placeholder="按号码搜索"
                size="medium"
                clearable
                suffix-icon="el-icon-search"
                 class="margin-left-20px"
                v-model.trim="searchPhone"
                @change="onSearchConditionChanged"
                @keyup.enter.native="onSearchConditionChanged('', true)"
              ></el-input>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <hr>
    <div v-loading="isLoading">
    <el-row>
      <el-table
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="salesAmount"
          label="销售总额"
        >
        </el-table-column>
        <el-table-column
          v-if="USERMANAGER.isFinancialManager || USERMANAGER.isAdmin"
          prop="salesIncome"
          label="销售收入"
        >
        </el-table-column>
        <el-table-column
          prop="totalBalanceCost"
          label="总使用余额"
        >
        </el-table-column>
        <el-table-column
          prop="advanceEnrollmentAmount"
          label="使用占位金额"
        >
        </el-table-column>
        <el-table-column
          prop="totalBonusPointAmount"
          label="总使用积分金额"
        >
        </el-table-column>
        <el-table-column
          prop="totalRefund"
          label="总退款"
        >
        </el-table-column>
        <!-- <el-table-column
          v-if="USERMANAGER.isFrontDesk"
          prop="percentage"
          label="总业绩百分比"
        >
        </el-table-column> -->
      </el-table>
    </el-row>
    <el-row v-if="USERMANAGER.isAdmin">
      <el-col>
        <pagination :data="refundListData" @loadData="onRefundListDataLoad" :option="paginationOption"></pagination>
      </el-col>
    </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-totalAmount {
  font-size: 25px;
  font-weight: bold;
}

.cs-amount {
  font-size: 25px;
}

.cs-recordCount {
  color: gray;
  margin-left: 10px;
}

.cs-datepick-col {
  width: 270px;

  .cs-accountList-searchDate {
    width: 250px !important;

    .el-range-separator {
      z-index: 99;
    }
  }
}
.cs-filter-rowItem{
  margin-bottom: 5px;
}
.cs-search-button{
  text-align: left;
}
body .cs-filter-row{
  padding-top: 0px;
}
</style>

<script>
import {
  addMonth,
  formatDate,
  getCourseType
} from "../../config/mUtils.js";
import {
  getTerms,
  getTrainingTerms,
  getUniversityGroups,
  getTrainingCategoryList
} from "../../service/common.service";
import { getEmployees } from "../../service/user.service";
import { getPerformanceEvaluationResult } from "../../service/finance.service.js";
import global_ from "@/core/global";
import pagination from "../common/pagination";

export default {
  props: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      employeeListData: [],
      universityGroups: [],
      accountTypeList: [],
      trainingCategoryList: [],
      englishCategoryList: [],
      termList:[],
      termListForCourseType:{},
      allEmployeeList:[],

      tableData: [
        {
          salesAmount: 0,
          salesIncome:0,
          totalBalanceCost: 0,
          advanceEnrollmentAmount: 0,
          totalBonusPointAmount: 0,
          totalRefund: 0
        }
      ],
      searchPhone: "",
      searchDate: "",
      selectedEmployeeId: "",
      selectedGroupNumber: "",
      selectedAccountType: "",
      selectedTrainingCategory: "",
      selectedEnglishCategory: "",
      currentTermId:0,
      selectedTermId: 0,
      isLoading: false,
      refundListData:{},
      paginationOption:{},
      listData: [],
      selectedSearchType: 1,
      courseType: 1,
      selectedRoleType: 0,

      searchTypes: [
        {
          Key: 1,
          Value: "按日期"
        },
        {
          Key: 2,
          Value: "按学期"
        },
        {
          Key: 3,
          Value: "学期和日期"
        }
      ],
      courseTypeList:[
        {
          Key: 1,
          Value: "大学补习"
        },
        {
          Key: 3,
          Value: "职业培训"
        },
      ],
      roleList:[
        {
          Key: 0,
          Value: "所有角色"
        },
        {
          Key: 1,
          Value: "前台销售"
        },
        {
          Key: 2,
          Value: "前台客服"
        },
      ]
    };
  },
  components: {
    navigator,
    pagination
  },
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: false,
      editButtonText: "编辑",
      hasAddButton: false,
      addButtonText: "添加",
      hasDeleteButton: false,
      hasSearch: false,
      hasEnableButton: false
    };
    if (this.USERMANAGER.isAdmin || this.USERMANAGER.isRegionCEO) {
      this.roleList.push({
        Key: 3,
        Value: "VIP销售"
      });
    }
    this.searchDate = [];
    let today = new Date();
    //let lastMonthDate = addMonth(today, -1);
    //this.searchDate.push(lastMonthDate);
    this.searchDate.push(today);
    this.searchDate.push(today);

    this.accountTypeList = [];
    this.accountTypeList.push({ key: 0, value: "所有收款类型" });
    this.accountTypeList.push({ key: 2, value: "只显示大学报名" });
    this.accountTypeList.push({ key: 9, value: "只显示职业培训报名" });
    this.accountTypeList.push({ key: 10, value: "只显示应试英语报名" });
    this.accountTypeList.push({ key: 3, value: "只显示会员" });
    this.accountTypeList.push({ key: 7, value: "只显示学业规划" });
    this.selectedAccountType = 0;

    getUniversityGroups().then(result => {
      if (!!result && result.success) {
        this.universityGroups = result.data;
        this.universityGroups.splice(0, 0, {
          GroupNumber: -1,
          NameValue: "不限大学"
        });
        this.selectedGroupNumber = -1;
      }
    });

    getTrainingCategoryList(3).then(result => {
      if (!!result && result.success) {
        this.trainingCategoryList = result.data;
        this.trainingCategoryList.splice(0, 0, {
          Id: 0,
          Name: "所有业务"
        });
      }
      this.selectedTrainingCategory = 0;
    });

    getTrainingCategoryList(2).then(result => {
      if (!!result && result.success) {
        this.englishCategoryList = result.data;
        this.englishCategoryList.splice(0, 0, {
          Id: 0,
          Name: "所有业务"
        });
      }
      this.selectedEnglishCategory = 0;
    });

    this.getEmployeeListData();
    this.getTermsByCourseType(()=>{
       this.search();
    })
  },
  methods: {
    async getEmployeeListData() {
      let list = this.GLOBAL.roleType.getOptionsByKeys([
        "sales",
        "assistant",
        "executiveManager",
        "receptionist",
      ]);
      if (this.USERMANAGER.isAdmin || this.USERMANAGER.isRegionCEO) {
        list.push(this.GLOBAL.roleType.keyOf("internationalSales"));
      } else if (this.USERMANAGER.isInternationalSales){
        list = [this.GLOBAL.roleType.keyOf("internationalSales")];
      }
      let roleTypes = list.map(enumOption => enumOption.value);
  
      let result = await getEmployees(roleTypes, "", null);

      if (result && result.success) {
        this.allEmployeeList = result.data.Results.map(i => {
          return { Id: i.UserId, Name: i.Name, RoleId: i.RoleId };
        });
      } else {
        this.allEmployeeList = [];
      }
      this.loadEmployeeList();
    },
    loadEmployeeList(){
      this.selectedEmployeeId = 0;
      let list = JSON.parse(JSON.stringify(this.allEmployeeList));
      if (this.selectedRoleType == 1){
        this.employeeListData = list.filter(i => i.RoleId != this.GLOBAL.roleType.receptionist 
          && i.RoleId != this.GLOBAL.roleType.internationalSales);
      }else if (this.selectedRoleType == 2){
        this.employeeListData = list.filter(i => i.RoleId == this.GLOBAL.roleType.receptionist);
      }else if (this.selectedRoleType == 3){
        this.employeeListData = list.filter(i => i.RoleId == this.GLOBAL.roleType.internationalSales);
      }else{
        this.employeeListData = list;
      }
      this.employeeListData.splice(0, 0, { Id: 0, Name: "所有行政人员", RoleId : 0 });
    },
    onSearchConditionChanged(name, isSearch) {
      if (name == "searchType" || name == "courseType" || name == "trainingCategory") {
        this.selectedTrainingCategory = 0;
        this.getTermsByCourseType(() => {
          if (isSearch){
            this.search();
          } 
        });
      } 
      else if (name == 'role'){
        this.loadEmployeeList();
        if (isSearch){
          this.search();
        } 
      }
      else {
        if (isSearch){
          this.search();
        } 
      }
    },
    setCurrentTerm(){
      let currentTerm = this.termList.filter(i => i.IsCurrentTerm);
      if (currentTerm && currentTerm.length > 0) {
        this.currentTermId = currentTerm[0].Id;
        this.selectedTermId = this.currentTermId;
      }
    },
    getTermsByCourseType(callback) {
      if (this.courseType == 2) {
        if (callback) {
          callback();
        }
      } else if (this.courseType == 1) {
        if (!this.termListForCourseType[1]){
          getTerms(true).then(result => {
            if (!!result && result.success) {
              this.termList = result.data;
              this.termListForCourseType[1] = result.data;
              this.setCurrentTerm();
              if (callback) {
                callback();
              }
            }
          });
        }else{
          this.termList = this.termListForCourseType[1];
          if (callback) {
            callback();
          }
        }
      } else if (this.courseType == 3) {
        if (!this.selectedTrainingCategory) {
          this.selectedTrainingCategory = this.trainingCategoryList[1].Id;
        }

        if (!this.termListForCourseType[3]){
          getTrainingTerms(true, this.selectedTrainingCategory).then(result => {
            if (!!result && result.success) {
              this.termList = result.data;
              this.termListForCourseType[3] = result.data;
              this.setCurrentTerm();
              if (callback) {
                callback();
              }
            }
          });
        }else{
          this.termList = this.termListForCourseType[3];
          this.setCurrentTerm();
          if (callback) {
            callback();
          }
        }
      }
    },
    search(pageData) {
      let searchData = this.getSearchPageData(pageData);
      this.loadEvaluationData(searchData);
    },

    loadEvaluationData(searchData) {
      this.isLoading = true;
      getPerformanceEvaluationResult(searchData)
        .then(result => {
          if (result && result.success) {
            this.tableData[0].salesAmount = result.data.SalesAmount;
            this.tableData[0].salesIncome = result.data.SalesIncome;
            this.tableData[0].totalBalanceCost = result.data.TotalBalanceCost;
            this.tableData[0].advanceEnrollmentAmount = result.data.AdvanceEnrollmentAmount;
            this.tableData[0].totalBonusPointAmount = result.data.TotalBonusPointAmount;
            this.tableData[0].totalRefund = result.data.TotalRefund;
            this.tableData[0].percentage = (result.data.Percentage * 100).toFixed(2).toString() + "%";

            if (this.USERMANAGER.isAdmin){
              this.refundListData = result.data.RefundData;
            }
            
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
        });
    },

    getSearchPageData(pageData) {
      let startDate = "";
      let endDate = "";

      if (!!this.searchDate && this.searchDate.length == 2) {
        startDate = formatDate(this.searchDate[0]);
        endDate = formatDate(this.searchDate[1]);
      }

      let categoryId = 0;
      if (this.selectedAccountType == 9) {
        categoryId = this.selectedTrainingCategory;
      } else if (this.selectedAccountType == 10) {
        categoryId = this.selectedEnglishCategory;
      }
      if (categoryId == "") {
        categoryId = 0;
      }

      let searchData = {
        SearchType: this.selectedSearchType,
        TermId: this.selectedTermId,
        StartDateText: startDate,
        EndDateText: endDate,
        SearchPhone: this.searchPhone,
        UserId: this.selectedEmployeeId == "" ? 0 : this.selectedEmployeeId,
        GroupNumber:
          this.selectedGroupNumber == "" ? -1 : this.selectedGroupNumber,
        AccountType:
          this.selectedAccountType == "" ? 0 : this.selectedAccountType,
        CategoryId: categoryId,
        RoleType: this.selectedRoleType
      };

      return searchData;
    },
    onRefundListDataLoad(){

    }
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/frontDesk/frontDeskPerformanceEvaluation.vue